import { render, staticRenderFns } from "./editCube13.vue?vue&type=template&id=6592fd74&scoped=true&"
import script from "./editCube13.vue?vue&type=script&lang=js&"
export * from "./editCube13.vue?vue&type=script&lang=js&"
import style0 from "./editCube13.vue?vue&type=style&index=0&id=6592fd74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6592fd74",
  null
  
)

export default component.exports